// extracted by mini-css-extract-plugin
export default {"verified_part":"buttons_verified_part__q4N-o","verified":"buttons_verified__lrlNw","restart_part":"buttons_restart_part__mxqhU","restart":"buttons_restart__bXwq1"};